import { render } from "./BookingView.vue?vue&type=template&id=1a0c282a&scoped=true"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"

import "./BookingView.vue?vue&type=style&index=0&id=1a0c282a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0c282a"]])

export default __exports__